var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"mb-4"},[_c('h2',{staticClass:"page-title"},[_vm._v(" Affilate Profile ")]),_c('tabs',{attrs:{"tabItems":_vm.TAB_ITEMS,"defaultTab":"general-details"}},[_c('template',{slot:"tab-content"},[_c(_vm.activeTabComponent,{tag:"component"}),_c('router-view')],1)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }